<template>
    <span>
    <div class="static-heaer" style="background: radial-gradient(circle, rgba(87,109,228,1) 0%, rgba(56,56,173,1) 100%); height: 80%">
        <div class="item-header2" >
           <div class="b-title">Contenido General</div>
            <ul style="font-size: 1.1rem">
                <li>Introducción general </li>
                 <li>Módulo 1. Aspectos éticos y legales de la Telesalud. Áreas de acción y ejemplos prácticos Queremos mostrarte los detalles éticos legales y documentales que implican estas herramientas, las diferentes áreas a explorar en sus usos y técnicas según los casos </li>
                 <li>Módulo 2. Teleconsultas de la teoría a la práctica y las herramientas a usar. Ejemplos prácticos Mostraremos los pasos prácticos para implementar la consulta en línea usando el método CPC, como hacer seguimiento y control así como formatos de preguntas y respuestas para pacientes.  </li>
                <li>Módulo 3. Marketing y ventas en salud. Se expondrán los 6 pasos básicos del marketing y venta de los servicios y productos de salud usando las herramientas tecnológicas actuales. Cada módulo consta de 6 videos y materiales descargables para trabajar los temas de cada uno

                </li>
                <li>
                    Cada módulo consta de 6 videos y materiales descargables para trabajar los temas de cada uno
                </li>
            </ul>
        </div>
        <div class="item-header">
            <div class="b-title" data-aos="flip-right">Toma acción ahora!</div>
            <ul style="font-size: 1.3rem">
                <li> <span style="font-size: 1.5rem; font-weight: 800">Clases magistrales <br>
                    (Dictadas por especialistas en el tema): </span><br>
                    o	Gestion del tiempo para profesionales de salud<br>
                    o	Redes sociales para servicios de salud. <br>
                    o	Google y su alcance en el área de salud. <br>
                    o	YouTube un buscador efectivo para la salud<br>
                    o	Copywriting para el área de salud<br>
                    o	Finanzas para personal de salud<br>
                    o	Manejo de imagen para personal de salud <br>
                    o	Los secretos para vencer el miedo a la cámara <br>
                    o	Manejo de plataformas de historias clínica<br>
                    o	Cómo cobrar la consulta en linea: vías de pago<br>

                </li>
            </ul>
         <div style="display: flex; justify-content: center; margin-top: 10px; text-align: center; flex-direction: column; align-items: center; z-index: 2">

                <router-link tag="div" to="/pro/Telemedicina/oferta" style="width: 230px; height: 80px; background-color: #FF4500; border: solid 1px white; border-radius: 10px; color: white; font-weight: 700; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 1.5rem">INSCRIBETE ÁQUI!</router-link>
            </div>

        </div>

    </div>
    <div id="questions" style="font-size: 3rem; padding: 10px 30px; text-align: center; background: radial-gradient(circle, rgba(87,109,228,1) 0%, rgba(56,56,173,1) 100%); color: white"><div   data-aos="flip-right">Preguntas y respuestas sobre Telemedicina A UN CLICK</div></div>
     <div class="static-heaer" style="background: radial-gradient(circle, rgba(87,109,228,1) 0%, rgba(56,56,173,1) 100%); height: 100%">
        <div class="item-header2" >
            <ul style="font-size: 1.1rem">
                <li><p>¿Cómo hago los récipes y las indicaciones?</p>
R: Se hacen con firma digital en un formato pdf y se envía al paciente por email y/o whatsapp según el caso<br><br>
</li>
                 <li><p>¿Cuánto tiempo dura una consulta en línea?</p>
R. Generalmente menos que una consulta presencial, dependiendo de cada especialidad, en promedio dura 30 minutos.<br><br>
 </li>
                <li><p>¿Cómo hago con el examen físico si hago consulta en línea?</p>
R. Según cada caso, el paciente pudiese tomarse presión arterial y peso y por video consulta le explica cómo medirse talla y cintura.
                    Ha formas fáciles de entrenar a los pacientes a hacerlo. Sabemos que la video consulta no podrá palpar, percutir
                    y auscultar al paciente más sin embargo un interrogatorio dirigido, y usar exploración superficial de algunas zonas específicas
                    via web, puede ayudar a orientar el caso y si requiere una exploración física, debe acudir a consulta presencial. Los estudios
                    demuestran que el 65 a 70% de los casos pueden resolverse de manera remota<br><br>
</li>
                <li><p>¿Necesito tener gran conocimiento de la tecnología para hacer consulta en línea?</p>
R. NO! Solo debes aprender a manejar programas sencillos y amigables, y estar dispuesto a familiarizarte con el uso expansivo
                    de muchas de las plataformas incluso que ya usas. Ya la tecnología ha evolucionado y nos da muchas herramientas sencillas de usar.<br><br>

                </li>
                <li>
                    <p>¿Y si los pacientes no regresan a la consulta en línea?</p>
R. Los estudios han demostrado que el 65 a 75% de los pacientes que prueban la consulta en línea, y ven que es fácil y
                    accesible, luego quieren volver a usar ese servicio. Es importante aplicar las herramientas propias de la
                    consulta para hacer enganche y rapport con el paciente, aun en línea.<br><br>

                </li>
            </ul>
        </div>
        <div class="item-header">
            <ul style="font-size: 1.1rem">
                <li>
                    <p>¿De dónde voy a sacar los pacientes para la consulta en línea?</p>
R. En el tercer módulo de marketing y ventas de servicios de salud, veras los pasos para lograrlo, como muchos ya lo hacemos.
                    Es aprender y usar el método probado, y aplicarlo.<br><br>
                </li>
                <li>
                    <p>¿Y si mi especialidad no sirve para telemedicina?</p>
R. Todas las áreas de la salud, en mayor o menor grado, pueden expandir sus servicios hacia la telemedicina, es un tema de aprender a explorar y combinarlo
                    con técnicas y herramientas para su aplicación. En este curso veras la expansión increíble que se tiene gracias a la Telemedicina<br><br>
                </li>
                <li>
                    <p>¿Esto serviría como para hacerme independiente profesionalmente y no depender de un sistema de salud público?</p>
R. Absolutamente SI! Puedes lograr alcanzar la independencia laboral si logras aplicar todo lo que enseñamos y vas creciendo en esta área.
                    La Telemedicina es un campo enorme que aun esta por expandirse en América Latina.<br><br>
                </li>
                <li>
                    <p>¿Todo el curso es en vivo?</p>
R. NO. Las sesiones de acompañamiento son en vivo, asi como las clases magistrales de esta edición. Los demás materiales son videos grabados que puedes
                    ver a tu ritmo y modo, y materiales descargables. Igualmente todas las sesiones en vivo son grabadas y quedan incluidas en la plataforma de tu curso<br><br>
                </li>
                <li>
                    <p>¿Cuánto tiempo tendré acceso al curso?</p>
                R. Las sesiones de acompañamiento son a la semana, a las 2 semanas, y al mes. Los videos y grabaciones de clases y sesiones tendrás acceso
                    permanente, para revisar y repasar conceptos.<br><br>
                </li>
            </ul>
         <div style="display: flex; justify-content: center; margin-top: 10px; text-align: center; flex-direction: column; align-items: center; z-index: 2">

                <router-link tag="div" to="/pro/Telemedicina/oferta" style="width: 230px; height: 80px; background-color: #FF4500; border: solid 1px white; border-radius: 10px; color: white; font-weight: 700; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 1.5rem">INSCRIBETE ÁQUI!</router-link>
            </div>

        </div>

    </div>
    </span>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                showModal: false
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    p{
        font-size: 1.4rem;
        font-weight: 800;
        color: yellow;
    }
    li{
        font-size: 1.3rem;
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 100vh;
        background-size: cover;
        background-repeat: no-repeat;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .video{
        width: 100%;
        height: 100%;

    }
    .item-header{
        width: 55%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
    }
    .item-header2{
        width: 55%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        text-shadow: 2px 2px 2px #0F4F84;
        padding: 20px 20px;
        color: white;
    }
    .b-title{
        font-size: 4rem;
        line-height: 5rem;
        font-weight: 800;
        text-align: center;
        font-family: 'Gayathri', sans-serif;
    }
    .b-title2{
        font-size: 3rem;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }


    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-containerx {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 600px;
        background-color: transparent;
        border-radius: 2px;
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0 0;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {

    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .item-header{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .item-header2{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .video{
            width: 95%;
            height: 200px;

        }
    }

    @media (min-width: 120px) and (max-width: 480px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .item-header{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .item-header2{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .video{
            width: 95%;
            height: 200px;

        }
    }
</style>